module.exports = __webpack_public_path__ + "static/media/logo.878a5ea5.png";